module.exports = __webpack_public_path__ + "static/media/telefon_przycisk.30cd443e.png";